import { hairLossFollowup, hairLossFollowup_archived } from './Followup/flow';
import { hairlossPhotos } from './HairlossPhotos/flow';
import { menHairLoss, menHairLoss_archived } from './Men/flow';
import { unisexHairLoss } from './Unisex/flow';
import { thareHairloss } from './Unisex/thare/flow';
import { womenHairLoss } from './Women/flow';

const HairLossFlows = {
  hairLossFollowup,
  hairLossFollowup_archived,
  womenHairLoss,
  menHairLoss,
  menHairLoss_archived,
  unisexHairLoss,
  hairlossPhotos,
  thareHairloss
};
export default HairLossFlows;
